import { render, staticRenderFns } from "./UserNotRegistred.vue?vue&type=template&id=a9f7e882&scoped=true&"
import script from "./UserNotRegistred.vue?vue&type=script&lang=js&"
export * from "./UserNotRegistred.vue?vue&type=script&lang=js&"
import style0 from "./UserNotRegistred.vue?vue&type=style&index=0&id=a9f7e882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f7e882",
  null
  
)

export default component.exports